import { matchSmall } from '../../application/utils/breakpoints'
import { Swiper, Pagination, Mousewheel } from 'swiper'

Swiper.use(Pagination)
Swiper.use(Mousewheel)

function createSwiper(swiperElement) {
  const videoHandler = async () => {
    const video = swiperElement.querySelector('.swiper-slide-active video')
    if (video) {
      await video.play()
    }
    swiperElement
      .querySelectorAll('.swiper-slide:not(.swiper-slide-active) video')
      .forEach(async (videoElement) => {
        await videoElement.pause()
      })
  }
  new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 10,
    mousewheel: {
      forceToAxis: true
    },
    loop: false,
    pagination: {
      el: swiperElement.querySelector('.swiper-pagination')
    },
    on: {
      init: videoHandler,
      slideChangeTransitionEnd: videoHandler
    }
  })
}

function destroySwiper(swiperElement) {
  if (swiperElement.swiper) {
    swiperElement.swiper.destroy(true, true)
    setTimeout(() => {
      swiperElement
        .querySelectorAll('.swiper-slide')
        .forEach((slide) => (slide.style = ''))
    })
  }
}

const matchInstance = matchSmall()

const swiperElements = []
document.querySelectorAll('.product__gallery').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  if (swiperElement) {
    swiperElements.push(swiperElement)
  }
})

function toggleState(matches) {
  if (matches) {
    swiperElements.forEach(createSwiper)
  } else {
    swiperElements.forEach(destroySwiper)
  }
}

if (swiperElements.length > 0) {
  toggleState(matchInstance.matches)
  matchInstance.subcribe(toggleState)
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach(async (entry) => {
    if (entry.isIntersecting) {
      await entry.target.play()
    } else {
      await entry.target.pause()
    }
  })
})
document.querySelectorAll('[data-product-video]').forEach((productVideo) => {
  const video = productVideo.querySelector('video')
  observer.observe(video)
  if (video) {
    productVideo.addEventListener(
      'click',
      async () => {
        await video.pause()
      },
      { once: true }
    )
  }
})
